import { API_URL } from "app/config";
import {
  selectCurrentRoles,
  selectCurrentToken,
  selectCurrentUser,
} from "features/auth/authSlice";
import { useState } from "react";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CardHeader, Col, Input, Label, Row, Spinner } from "reactstrap";
import swal from "sweetalert";
import KycDetailEdit from "./KycDetailEdit";

const SaathiPersonalDetailsEdit = ({
  SaathiUserData,
  SaathiDetailsRefetch,
}) => {
  const { id } = useParams();
  const [isEdit, setisEdit] = useState(false);
  const [loader, setLoader] = useState(false);
  const currentUser = useSelector(selectCurrentUser);
  const user_token = useSelector(selectCurrentToken);
  const RolesFromToken = useSelector(selectCurrentRoles);

  const handleEdit = () => {
    setisEdit(true);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [PersonalDetails, setPersonalDetails] = useState({
    LegalEntityType: "",
    firstName: "",
    lastName: "",
    email: "",
    alternatePhoneNumber: "",
  });

  const onInputChange = (event) => {
    setPersonalDetails({
      ...PersonalDetails,
      [event.target.name]: event.target.value,
    });
  };

  const onSubmitSaathiData = (data) => {
    setLoader(true);
    var jsonData = {
      individuals: SaathiUserData?.personal_details?.individuals,
      firstName: PersonalDetails?.firstName || SaathiUserData.firstName,
      lastName: PersonalDetails?.lastName || SaathiUserData.lastName,
      phoneNumber: SaathiUserData?.phoneNumber,
      alternatePhoneNumber:
        PersonalDetails?.alternatePhoneNumber ||
        SaathiUserData?.personal_details?.alternatePhoneNumber,
      email: SaathiUserData.email || PersonalDetails.email,
      ui_section_id: "1",
      created_by: currentUser.sub,
      created_by_name: currentUser.name,
      empanelment_agent_id: currentUser.sub,
    };

    fetch(`${API_URL}/empanelment/api/existing-user/${id}`, {
      method: "PUT",
      body: JSON.stringify(jsonData),
      headers: {
        Authorization: `Bearer ${user_token}`,
        "Content-Type": "application/json",
      },
    })
      .then((r) => r.json())
      .then((resp) => {
        const result = resp;
        if (result.status === 200 || result.status === 201) {
          swal("Success", {
            buttons: false,
            icon: "success",
            title: result.message,
            timer: 1500,
          });
          setLoader(false);
          setisEdit(false);
          SaathiDetailsRefetch(id);
        } else {
          swal("Success", {
            buttons: false,
            icon: "warning",
            title: result.message,
            timer: 1500,
          });
          setLoader(false);
        }
      });
  };

  return (
    <div>
      <Row>
        <CardHeader
          style={{ padding: "13px" }}
          className=" mb-3 d-flex justify-content-between align-items-center"
        >
          <h5 className="m-0">Personal Details </h5>

          {RolesFromToken.groups?.includes("Maker") ? (
            SaathiUserData?.onboarding_status === "QC1 Approved" ? (
              ""
            ) : (
              <div>
                {" "}
                {isEdit ? (
                  <Button
                    size="sm"
                    id="editDetails"
                    type=""
                    className=" btn-danger waves-effect  "
                    onClick={() => setisEdit(false)}
                  >
                    Cancel <i className="mdi mdi-window-close"></i>
                  </Button>
                ) : (
                  <Button
                    size="sm"
                    id="editDetails"
                    type=""
                    className="  waves-effect  "
                    onClick={handleEdit}
                  >
                    Edit <i className="mdi mdi-file-edit-outline"></i>
                  </Button>
                )}
              </div>
            )
          ) : (
            ""
          )}
        </CardHeader>
        <form onSubmit={handleSubmit(onSubmitSaathiData)}>
          <Row className="mb-3">
            <Col lg="3" className="mb-2">
              <Label>Entity Type</Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.personal_details?.individuals}
                disabled
                className="rounded-1"
              />
            </Col>

            <Col lg="3" className="mb-2">
              <Label>First Name</Label>
              <Input
                name="firstName"
                defaultValue={SaathiUserData?.firstName}
                disabled={isEdit === true ? false : true}
                onChange={onInputChange}
                className="rounded-1"
              />
            </Col>
            <Col lg="3" className="mb-2">
              <Label>Last Name</Label>
              <Input
                name="lastName"
                defaultValue={SaathiUserData?.lastName}
                disabled={isEdit === true ? false : true}
                onChange={onInputChange}
                className="rounded-1"
              />
            </Col>
            <Col lg="3" className="mb-2">
              <Label>Phone No.</Label>
              <Input
                name=""
                defaultValue={SaathiUserData?.phoneNumber}
                disabled
                className="rounded-1"
              />
            </Col>
            <Col lg="3" className="mb-2">
              <Label>Alternate Phone Number</Label>
              <Input
                name="alternatePhoneNumber"
                defaultValue={
                  SaathiUserData?.personal_details?.alternatePhoneNumber
                }
                disabled={isEdit === true ? false : true}
                onChange={onInputChange}
                type="number"
                className="rounded-1"
                placeholder="Enter No."
              />
            </Col>
            <Col lg="3" className="mb-2">
              <Label>Email</Label>
              <Input
                name="email"
                type="email"
                defaultValue={SaathiUserData?.email}
                disabled={isEdit === true ? false : true}
                onChange={onInputChange}
                className="rounded-1"
                placeholder="Enter Email"
              />
            </Col>

            {isEdit === true ? (
              <div className="col-lg-12 text-center m-auto p-2">
                <button type="submit" className="btn btn-success p-3">
                  <span class="mdi mdi-content-save "></span> Update Personal
                  Details &nbsp;
                  {loader ? (
                    <Spinner animation="border" size="sm"></Spinner>
                  ) : (
                    ""
                  )}
                </button>
              </div>
            ) : (
              ""
            )}
          </Row>
        </form>
        <div>
          <KycDetailEdit
            SaathiUserData={SaathiUserData}
            SaathiDetailsRefetch={SaathiDetailsRefetch}
          />
        </div>
        {/* <Row>
        <KycDetails/>
    </Row> */}
      </Row>
    </div>
  );
};

export default SaathiPersonalDetailsEdit;
